// auth-service accepts `otpType` + `identifier` and returns camelCase wrapped in
// a gateway `data` envelope. The only payload we actually read back is the
// VerifyOtp response (requestToken).

export const OTP_TYPE_CHANGE_PHONE = 'change_phone';

export interface ISendOtpApiPayload {
  otpType: typeof OTP_TYPE_CHANGE_PHONE;
  identifier: string;
}

export type TSendOtpApiResponse = Record<string, unknown>;

export interface IVerifyOtpApiPayload {
  otpType: typeof OTP_TYPE_CHANGE_PHONE;
  identifier: string;
  otpCode: string;
}

export interface IVerifyOtpApiResponse {
  requestToken: string;
}

export interface IVerifyOtpApiEnvelope {
  data: IVerifyOtpApiResponse;
}

export interface ISetPhoneApiPayload {
  requestToken: string;
  newPhone: string;
}

export type TSetPhoneApiResponse = Record<string, unknown>;
